export default __webpack_public_path__ + "static/media/kia.d2b9f7ae.jpg";